import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import dotIndigoIcon from "assets/img/icons/icons8-dot-indigo.svg";

const Item = styled(Link)`
  margin-top: 5px;

  color: #fff;
  text-decoration: none;
`;

const ItemBackground = styled.div`
  width: 42px;
  height: 42px;
  box-sizing: border-box;

  border-radius: ${(props) => (props.wide ? "0" : "21px")};
  background: ${(props) =>
    props.current && !props.wide ? css.FLAT_BOX_BACKGROUND : "transparent"};

  transition: 0.2s;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${css.FLAT_BOX_BACKGROUND};
  }
`;

const ItemIcon = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
  box-sizing: border-box;

  background-image: url(${(props) => props.icon});
  background-repeat: no-repeat;
  background-size: cover;

  transform: ${(props) =>
    props.translate ? `translateX(${props.translate})` : "none"};
`;

export default ({ to, icon, iconCurrent, target = "_self", translate }) => {
  const location = useLocation();
  const { pathname } = location;

  const tabletScreen = useMediaQuery({
    query: `(max-width: ${globalConstants.switchTablet})`,
  });

  let currentPath = pathname === to;

  if (pathname === "/chat" && to === "/messages") currentPath = true;

  return (
    <Item to={to} target={target}>
      <ItemBackground current={currentPath ? 1 : 0} wide={tabletScreen ? 1 : 0}>
        <ItemIcon
          icon={currentPath ? iconCurrent : icon}
          translate={translate}
        />
      </ItemBackground>
    </Item>
  );
};
